import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import client from '../../api/client';
import { popupFrequencyOk, usePopupStore } from '../../stores/popupStore';
import NoticePopup from './NoticePopup';
import UpgradePopup from './UpgradePopup';

// B1：编辑器弹窗宿主（挂 EditorLayout，/editor/scene/:id 生效）
// 进入 3D 编辑器且为免费/带水印用户时：
//  1) 温馨提示（frequencyHours=0 默认每次进入都弹）→ 关闭 10s 倒计时；「不再提示」仅本次
//  2) 套餐订阅：由「不再提示」/顶部升级条触发；也支持频率自动弹（默认 1 小时最多一次）
export default function PopupHost() {
  const location = useLocation();
  const loaded = usePopupStore((s) => s.loaded);
  const config = usePopupStore((s) => s.config);
  const noticeDismissed = usePopupStore((s) => s.noticeDismissed);
  const lastNoticeAt = usePopupStore((s) => s.lastNoticeAt);
  const lastUpgradeAt = usePopupStore((s) => s.lastUpgradeAt);
  const loadConfig = usePopupStore((s) => s.loadConfig);

  const [watermark, setWatermark] = useState<boolean | null>(null);
  const decided = useRef(false);
  const inEditor = location.pathname.startsWith('/editor/scene');

  useEffect(() => {
    void loadConfig();
  }, [loadConfig]);

  useEffect(() => {
    client
      .get('/auth/quota')
      .then((r) => setWatermark(r.data?.watermark !== false))
      .catch(() => setWatermark(true)); // 读取失败按安全策略=带水印（与 useWatermarkFlag 一致）
  }, []);

  useEffect(() => {
    if (decided.current || !loaded || watermark === null || !inEditor) return;
    decided.current = true;
    if (!watermark) return; // 付费/去水印用户：不弹
    const n = config.notice ?? {};
    const u = config.upgrade ?? {};
    if (n.enabled !== false && !noticeDismissed && popupFrequencyOk(lastNoticeAt, n.frequencyHours)) {
      usePopupStore.getState().openNotice();
      return;
    }
    if (u.enabled !== false && popupFrequencyOk(lastUpgradeAt, u.frequencyHours)) {
      usePopupStore.getState().openUpgrade();
    }
  }, [loaded, watermark, inEditor, config, noticeDismissed, lastNoticeAt, lastUpgradeAt]);

  return (
    <>
      <NoticePopup />
      <UpgradePopup />
    </>
  );
}
